import { TaskDefinition } from '@/feature/execution-board'
import { useAssetTelemetry } from '@/feature/telemetry'

import { useSingleVehicle } from '@/lib/features/Assets/api'

// The assigned asset's current live position (from telemetry), or null when the task has no
// assigned vehicle or no live telemetry has arrived for it yet.
export const useTaskAssetPosition = (task: TaskDefinition): google.maps.LatLngLiteral | null => {
  const { data: vehicle } = useSingleVehicle(
    task.assignedVehicle ? { id: task.assignedVehicle.id } : null,
  )

  // Passing `undefined` makes useAssetTelemetry return the whole telemetry map, so coalesce the
  // not-yet-loaded case to `null` (which resolves to a single missing entry → undefined).
  const telemetry = useAssetTelemetry(vehicle?.vehicleBridgeId ?? null)

  return telemetry ? { lat: telemetry.latitude, lng: telemetry.longitude } : null
}
